import styles from './spinner.module.css'

export default function Spinner ({ size = 20, className, style }: { size?: number, className?: string, style?: React.CSSProperties }) {
  return (
    <svg
      width={size}
      height={size}
      style={style}
      viewBox="-1.25 -1.25 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={[styles.spinner, className].filter(Boolean).join(' ')}
      aria-hidden="true"
    >
      <path d="M8.75 0C9.16421 0 9.5 0.335786 9.5 0.75C9.5 1.16421 9.16421 1.5 8.75 1.5C4.74594 1.5 1.5 4.74594 1.5 8.75C1.5 12.7541 4.74594 16 8.75 16C11.176 16 13.3234 14.8088 14.6406 12.9766C14.8824 12.6404 15.3512 12.5641 15.6875 12.8057C16.0238 13.0474 16.101 13.5162 15.8594 13.8525C14.2724 16.06 11.6792 17.5 8.75 17.5C3.91751 17.5 0 13.5825 0 8.75C0 3.91751 3.91751 0 8.75 0Z" fill="currentColor" />
    </svg>
  )
}
